import React from "react";
import styles from "../styles/Credentials.module.css";
import PnbLife from "../img/pnb_matlife.svg";
import Finfra from "../img/Finfra.svg";
import mosaic from "../img/mosaic.svg";
import CHNHB from "../img/CHNHB.svg";
import Fintech from "../img/Fintech.svg";
import AVIVA from "../img/AVIVA.svg";
import Homehealth from "../img/Homehealth.svg"
import mcura from "../img/mcura.svg"
import mamily from "../img/mamily.svg"
import prometheon from "../img/prometheon.svg"
import pvt from "../img/pvtequity.svg"
import seedoc from "../img/Seedoc.svg"
import Aakash from "../img/Aakash.svg"
import Singer from "../img/Singer.svg"
import Arivatic from "../img/Arivatic.svg"
import privatee from "../img/Private.svg"

const Credentials = () => {
  return (
    <div id="credentials" className={styles.credentials_container}>
      <h1>Our Credentials</h1>
      <p>
        Trusted by leading organizations across Financial Services, HealthTech,
        InsureTech, and <br /> diverse industry sectors
      </p>
      <div className={styles.credential_heading}>
        <h2>Credentials in the Financial Services space</h2>
      </div>
      <div className={styles.credentials_grid}>
        <div className={styles.credentials_child}>
          <div>
            <img src={PnbLife} alt="pnb-life" />
            <div>
              <h3>PNB MetLife Insurance</h3>
              <p>Life and Retirement</p>
            </div>
          </div>
          <div>
            <img src={Finfra} alt="Finfra" />
            <div>
              <h3>FIINFRA</h3>
              <p>B2B Technology Platform for IFAs</p>
            </div>
          </div>
          <div>
            <img src={mosaic} alt="mosaic" />
            <div>
              <h3>Mosaic Capital</h3>
              <p>Wealth Management</p>
            </div>
          </div>
          <div>
            <img src={CHNHB} alt="CHNHB" />
            <div>
              <h3>CHNHB Health Insurance</h3>
              <p>Health Insurance</p>
            </div>
          </div>
          <div>
            <img src={Fintech} alt="Fintech" />
            <div>
              <h3>Fintech Company</h3>
              <p>SME Business Loans Marketplace</p>
            </div>
          </div>
          <div>
            <img src={AVIVA} alt="AVIVA" />
            <div>
              <h3>AVIVA</h3>
              <p>Bancassurance</p>
            </div>
          </div>
        </div>
      </div>
      {/* 2nd */}

      <div className={styles.credential_heading}>
        <h2>Credentials in Health Services & Health Tech Advisory</h2>
      </div>
      <div className={styles.credentials_grid}>
        <div className={styles.credentials_child}>
          <div>
            <img src={Homehealth} alt="Homehealth" />
            <div>
              <h3>Home Health Care</h3>
              <p>Home HealthCare Services Company</p>
            </div>
          </div>
          <div>
            <img src={mcura} alt="mcura" />
            <div>
              <h3>Mcura</h3>
              <p>Health Records and Smart OPD</p>
            </div>
          </div>
          <div>
            <img src={mamily} alt="mamily" />
            <div>
              <h3>Mamily</h3>
              <p>Maternity</p>
            </div>
          </div>
          <div>
            <img src={prometheon} alt="prometheon" />
            <div>
              <h3>Promethean Health tech</h3>
              <p>AI Based Blood Analytics</p>
            </div>
          </div>
          <div>
            <img src={pvt} alt="pvt-eq" />
            <div>
              <h3>Sabre Partners</h3>
              <p>Operating Partner and Fund <br /> Raising Private Equity</p>
            </div>
          </div>
          <div>
            <img src={seedoc} alt="seedoc" />
            <div>
              <h3>SEEDOC</h3>
              <p>(Revival Project) for Ayushman Bharat</p>
            </div>
          </div>
        </div>
      </div>

      {/* 3rd */}

       <div className={styles.credential_heading}>
        <h2>Credentials in Insuretech & Other Sectors</h2>
      </div>
      <div className={styles.credentials_grid}>
        <div className={styles.credentials_child}>
          <div>
            <img src={Aakash} alt="Aakash" />
            <div>
              <h3>Aakash Education</h3>
              <p>Edtech Company</p>
            </div>
          </div>
          <div>
            <img src={Singer} alt="Singer" />
            <div>
              <h3>Singer India</h3>
              <p>Fast Moving Consumer Durables</p>
            </div>
          </div>
          <div>
            <img src={Arivatic} alt="Arivatic" />
            <div>
              <h3>Arivatic</h3>
              <p>AI Based Insuretech Platform</p>
            </div>
          </div>
          <div>
            <img src={Finfra} alt="finfra" />
            <div>
              <h3>Pantera Capital</h3>
              <p>Asia Insurance Fund - <br /> Operating Partner India</p>
            </div>
          </div>
          <div>
            <img src={privatee} alt="privatee" />
            <div>
              <h3>Private Equity Fund Advisory</h3>
              <p>For investment in Insurance Sector & Broking companies</p>
            </div>
          </div>
          <div>
            <img src={AVIVA} alt="Aviva" />
            <div>
              <h3>JAYKAY Enterprises</h3>
              <p>Defence Tech</p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cred_grid_main}>
        <div className={styles.cred_grid_child}>
          <div className={styles.cred_grid}>
            <h2>18+</h2>
            <p>Partner Organisation</p>
          </div>
          <div className={styles.cred_grid}>
            <h2>3</h2>
            <p>Key Industry Sectors</p>
          </div>
          <div className={styles.cred_grid}>
            <h2>100%</h2>
            <p>Client Satisfaction</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Credentials;
